import { render, staticRenderFns } from "./CreateBay.vue?vue&type=template&id=3b828ce8&"
import script from "./CreateBay.vue?vue&type=script&lang=js&"
export * from "./CreateBay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports